import { createSelector } from 'reselect';

const teamMembersFull = state => state.teamMembersFullReducer;
const userProgramsFull = state => state.userProgramsFullReducer;
const messageList = state => state.messagesListReducer;

export const getCoachesProjects = createSelector(
  teamMembersFull, 
  projectsFull => { 
    console.log('CALL ME getCoachesProjects', projectsFull)
    return projectsFull.projects !== null && projectsFull.projects
  }
  );

  export const selectedProjectId = createSelector(
    userProgramsFull,
    programs => {
      console.log('CALL ME selectedProjectId', programs.selectedProjectId)
      return programs.selectedProjectId !== null ? programs.selectedProjectId : null
    }
  );

  export const selectedRolloutId = createSelector(
    userProgramsFull,
    programs => {
      console.log('CALL ME selectedRolloutId', programs.selectedRollout !== null ? programs.selectedRollout : null)
      return programs.selectedRollout !== null ? programs.selectedRollout : null
    }
  );

  export const selectedProject = createSelector(
    getCoachesProjects,
    selectedProjectId,
    (projects, _selectedProjectId) => {
      console.log('CALL ME selectedProject',projects, _selectedProjectId,(projects && Array.isArray(projects)) ? projects.find(projects => projects.id === _selectedProjectId) : null)
      return  (projects && Array.isArray(projects)) ? projects.find(projects => projects.id === _selectedProjectId) : null
    }
     
  );

  export const selectedRollout = createSelector(
    selectedProject,
    selectedRolloutId,
    (rollouts, _selectedRolloutId) => {
      console.log('CALL ME selectedRollout', rollouts, _selectedRolloutId)
      return  (rollouts && Array.isArray(rollouts.program.rollouts)) ? rollouts.program.rollouts.find(rollout => rollout.rollout_id === _selectedRolloutId) : null
    }
     
  );

  export const getRolloutsForProject = createSelector(
    selectedProject, 
    project=> { 
      console.log('CALL ME getRolloutsForProject', project)
      return (project && project.program.rollouts !== null) ? project.program.rollouts : null
    }
  );

  export const getUsersForRollout = createSelector(
    selectedRollout, 
    rollout=> { 
      console.log('CALL ME getUsersForRollout', rollout)
      return (rollout && rollout.users !== null) ? rollout.users : null
    }
  );


  

  export const getSelectedProject= createSelector(
    getCoachesProjects,
    selectedProjectId,
    (rollouts, _selectedProjectId) => {
      return  Array.isArray(rollouts) && rollouts.find(rollouts => rollouts.id === _selectedProjectId)
    }
     
  );

export const getCoachesPrograms = createSelector(
  teamMembersFull, 
  programsFull => { 
    console.log('USERS', programsFull)
    return programsFull.programs !== null && programsFull.programs
  }
  );

  export const getAllUsers = createSelector(
    teamMembersFull,
    programs => Array.isArray(programs) && module.reduce((acc, curr) => [...acc, ...curr.users], []),
);
export const getAllRollouts = createSelector(
  teamMembersFull,
  projects => Array.isArray(projects) && program.reduce((acc, curr) => [...acc, ...curr.rollouts], []),
);

export const selectedProgramId = createSelector(
    userProgramsFull,
    programs => {
      return programs.selectedProgramId !== null ? programs.selectedProgramId : null
    }
  );

  

export const selectedProgram = createSelector(
    getCoachesPrograms,
    selectedProgramId,
    (programs, _selectedProgramId) => {
      return  (programs && Array.isArray(programs)) ? programs.find(program => program.programId === _selectedProgramId) : null
    }
     
  );

  

  export const getUsersForProgram = createSelector(
    selectedProgram, 
    program=> { 
      console.log('USERS2', program)
      return (program && program.users !== null) ? program.users : null
    }
  );

  

  

  export const selectedContentId = createSelector(
      userProgramsFull,
      programs => programs.selectedContentId,
    );

  export const selectedUserId = createSelector(
    userProgramsFull,
    programs => {
      return programs.selectedUserId
    }
  );
  export const selectedUser= createSelector(
    getUsersForRollout,
    selectedUserId,
    (users, _selectedUserId) => {
      return  Array.isArray(users) ? users.find(user => user.user_id === _selectedUserId) : null
    }
     
  );

  export const getThinkToolsForUser= createSelector(
    selectedUser, 
    user=> { 
      return user && user.thinktools !== null && user.thinktools
    }
  );

  export const selectedThinktoolId = createSelector(
    userProgramsFull,
    programs => {
      return programs.selectedThinkToolId
    }
  );

  export const getSelectedThinktool= createSelector(
    getThinkToolsForUser,
    selectedThinktoolId,
    (thinktools, _selectedThinktoolId) => {
      return  Array.isArray(thinktools) && thinktools.find(thinktools => thinktools.contentId === _selectedThinktoolId)
    }
     
  );

  export const getVersionsForThinktool= createSelector(
    getSelectedThinktool, 
    thinktool=> { 
      console.log('selectedVERSions', thinktool)
      return thinktool.versions !== null && thinktool.versions
    }
  );

  export const selectedVersionId = createSelector(
    userProgramsFull,
    programs => {
      return programs.selectedVersionId
    }
  );

  export const getSelectedVersion= createSelector(
    getVersionsForThinktool,
    selectedVersionId,
    (versions, _selectedVersionId) => {
      return  Array.isArray(versions) && versions.find(version => version.version_id === _selectedVersionId)
    }
     
  );

  // export const getMessageList = createSelector(
  //     selectedThinkTool,
  //     selectedTT => (selectedTT ? selectedTT.messages.reverse() : []),
  //   );
  
  export const getUsersMessageList = createSelector(
      messageList,
      messages => (Array.isArray(messages.list) ? messages.list : []),
    );
    export const getUsersMessageSent = createSelector(
      messageList,
      messages => (Array.isArray(messages.sentlist) ? messages.sentlist : []),
    );
  


// export const getUsersForProgram = createSelector(
//   selectedProgram,
//   users => selectedUsersProgram.users,
// );

// export const getSelectedUser = createSelector(
//   teamMembersFull,
//   teamMembers => teamMembers.selectedTeamMemberId,
// );

// export const selectedUser = createSelector(
//   getSelectedUser,
//   getUsersFull,
//   (selectedUserId, getUsers) =>
//     Array.isArray(getUsers) && getUsers.find(user => user.userId === selectedUserId),
// );

// export const getAllTT = createSelector(
//   selectedUser,
//   selectedUserObject => (selectedUserObject && selectedUserObject.thinktools) || [],
// );

// export const getSelectedTT = createSelector(
//   teamMembersFull,
//   teamMembers => teamMembers.selectedThinkToolId,
// );

// export const selectedThinkTool = createSelector(
//   getAllTT,
//   getSelectedTT,
//   (thinkToolsList, selectedTT) =>
//     Array.isArray(thinkToolsList) &&
//     thinkToolsList.find(thinkTool => thinkTool.contentId === selectedTT),
// );

// export const getReport = createSelector(
//   selectedThinkTool,
//   selectedThinkToolObject => selectedThinkToolObject.report,
// );

// export const getVersions = createSelector(
//   selectedThinkTool,
//   selectedThinkToolObject => (selectedThinkToolObject ? selectedThinkToolObject.versions : []),
// );

// export const getSelectedVersion = createSelector(
//   teamMembersFull,
//   teamMembers => teamMembers.selectedVersionId,
// );
// export const selectedVersion = createSelector(
//   getVersions,
//   getSelectedVersion,
//   (versionsList, selectedVersionItem) =>
//     Array.isArray(versionsList) &&
//     versionsList.find(version => version.versionId === selectedVersionItem),
// );

// export const getMessageList = createSelector(
//   selectedThinkTool,
//   selectedTT => (selectedTT ? selectedTT.messages.reverse() : []),
// );
// export const getSelectedMessage = createSelector(
//   teamMembersFull,
//   teamMembers => teamMembers.selectedMessageId,
// );
// export const selectedMessage = createSelector(
//   getMessageList,
//   getSelectedMessage,
//   (messagesList, selectedMessageObject) =>
//     Array.isArray(messagesList) &&
//     messagesList.find(message => message.id === selectedMessageObject),
// );
// // ______________________________________USER SELECTORS______________________________________
// const userProgramsFull = state => state.userProgramsFullReducer;
// export const messageList = state => state.messagesListReducer;

// export const getPrograms = createSelector(
//   userProgramsFull,
//   programsFull => programsFull !== null && programsFull,
// );



// export const selectedProgramId = createSelector(
//   userProgramsFull,
//   programs => programs.selectedProgramId,
// );

// export const selectedProgram = createSelector(
//   teamMembersFull,
//   selectedProgramId,
//   (programs, _selectedProgramId) =>
//     Array.isArray(programs) && programs.find(program => program.programId === _selectedProgramId),
// );

// export const getUserModules = createSelector(
//   selectedProgram,
//   selectedUsersProgram => selectedUsersProgram.modules,
// );
// export const selectedModuleId = createSelector(
//   userProgramsFull,
//   programs => programs.selectedModuleId,
// );
// export const selectedModule = createSelector(
//   getUserModules,
//   selectedModuleId,
//   (modules, _selectedModuleId) =>
//   Array.isArray(modules) && modules.find(module => module.moduleId === _selectedModuleId),
// );

// export const getUserModuleContent = createSelector(
//   selectedModule,
//   selectedUsersModule => selectedUsersModule && selectedUsersModule.content,
// );
// export const selectedContentId = createSelector(
//   userProgramsFull,
//   programs => programs.selectedContentId,
// );
// export const selectedContentItem = createSelector(
//   getUserModuleContent,
//   selectedContentId,
//   (modulesContent, _selectedContentId) =>
//     Array.isArray(modulesContent) &&
//     modulesContent.find(contentItem => contentItem.contentId === _selectedContentId),
// );


// export const messageTitle = createSelector(
//   selectedContentItem,
//   selectedThinkTool,
//   (selectedContentItem, selectedThinkTool) =>
//     selectedContentItem ? selectedContentItem.name : selectedThinkTool.name,
// );
// export const getUsersMessageList = createSelector(
//   messageList,
//   messages => (Array.isArray(messages.list) ? messages.list.reverse() : []),
// );

// // __________________________SELECTORS FOR TOOLS PAGE______________________________________________
// export const getAllModules = createSelector(
//   getPrograms,
//   programs =>
//     Array.isArray(programs) && programs.reduce((acc, curr) => [...acc, ...curr.modules], []),
// );

// export const getAllContent = createSelector(
//   getAllModules,
//   module => Array.isArray(module) && module.reduce((acc, curr) => [...acc, ...curr.content], []),
// );

// export const getAllThinkTools = createSelector(
//   getAllContent,
//   content =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.type === 'ThinkTool'),
// );

// export const getSelectedThinktool = createSelector(
//   getAllContent,
//   selectedContentId,
//   (content, _selectedContentId) =>
//     Array.isArray(content) && content.find(contentItem => contentItem.contentId === _selectedContentId),
// );

// export const getAllThinkToolsAndJournals = createSelector(
//   getAllContent,
//   content =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.type === 'ThinkTool' || contentItem.type === 'Journal') ,
// );

// export const getAllAssignments = createSelector(
//   getAllContent,
//   content =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.type === 'Assignments'),
// );

// export const getAllAssignmentsCurrent = createSelector(
//   getAllContent,
//   selectedProgramId,
//   (content, _selectedProgramId) =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.program_id === _selectedProgramId  && contentItem.type === 'Assignments'  && (contentItem.status!=='completed')),
// );

// export const getAllToolsCurrent = createSelector(
//   getAllContent,
//   selectedProgramId,
//   (content, _selectedProgramId) =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.program_id === _selectedProgramId  && contentItem.type === 'ThinkTool'  && (contentItem.status!=='completed')),
// );

// export const getAvailableAssignments = createSelector(
//   getAllContent,
//   content =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.type === 'Assignments' && (contentItem.status=='ready' || contentItem.status=='not started' || contentItem.status=='in progress' || contentItem.status=='submitted')),
// );
// export const getExtensionAssignments = createSelector(
//   getAllContent,
//   content =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.type === 'Assignments' && (contentItem.status=='extension_request')),
// );
// export const getResubAssignments = createSelector(
//   getAllContent,
//   content =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.type === 'Assignments' && (contentItem.status=='resubmission_request')),
// );
// export const getMarkingAssignments = createSelector(
//   getAllContent,
//   content =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.type === 'Assignments' && (contentItem.status=='marking')),
// );
// export const getCompleteAssignments = createSelector(
//   getAllContent,
//   content =>
//     Array.isArray(content) && content.filter(contentItem => contentItem.type === 'Assignments' && (contentItem.status=='completed')),
// );
// // __________________________SELECTORS FOR TOOLS PAGE______________________________________________



// WEBPACK FOOTER //
// ./src/redux/selectors/index.js